import { z } from 'zod';

export interface Rating {
  readonly id: string;
  readonly applicationId: string;
  readonly raterId: string;
  readonly rateeId: string;
  readonly stars: number;
  readonly comment: string | null;
  readonly createdAt: string;
}

const rowSchema = z.object({
  id: z.string(),
  application_id: z.string(),
  rater_id: z.string(),
  ratee_id: z.string(),
  stars: z.number(),
  comment: z.string().nullable(),
  created_at: z.string(),
});

export function mapRating(row: unknown): Rating {
  const r = rowSchema.parse(row);
  return {
    id: r.id,
    applicationId: r.application_id,
    raterId: r.rater_id,
    rateeId: r.ratee_id,
    stars: r.stars,
    comment: r.comment,
    createdAt: r.created_at,
  };
}

export interface RatingInput {
  readonly applicationId: string;
  readonly rateeId: string;
  readonly stars: number;
  readonly comment: string | null;
}
